import { render, staticRenderFns } from "./MultiChoiceQuestionModal.vue?vue&type=template&id=1b2cd0ea&scoped=true"
import script from "./MultiChoiceQuestionModal.vue?vue&type=script&lang=js"
export * from "./MultiChoiceQuestionModal.vue?vue&type=script&lang=js"
import style0 from "./MultiChoiceQuestionModal.vue?vue&type=style&index=0&id=1b2cd0ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2cd0ea",
  null
  
)

export default component.exports